import { Component, Inject, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageInPreviewVM, ImageViewerVM } from 'src/app/shared/interfaces/image-viewer.interface';
import { BaseImageViewer } from 'src/app/shared/classes/base-image-viewer';
import { FireStorageService } from 'src/app/shared/services/storage.service';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent extends BaseImageViewer {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImageViewerVM,
    ctxDS: ContextDataService,
    storageService: FireStorageService,
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) document: Document,
  ) {
    super(ctxDS, storageService, rendererFactory, document);
  }

  public get currentImage(): ImageInPreviewVM {
      return this.data.image;
  }

  public get isDefectDetailsView(): boolean {
      return this.data.layout === 'defect-details';
  }
}
